<template>
  <div class="rpo-shell" dir="rtl" @click.self="$emit('close')">
    <div class="rpo-card">
      <button type="button" class="rpo-close" @click="$emit('close')" aria-label="סגור">✕</button>
      <div class="rpo-logo">TOV+</div>

      <div v-if="!done">
        <h2 class="rpo-title">הגדרת סיסמה חדשה</h2>
        <p class="rpo-sub">הזן/י סיסמה חדשה לחשבון שלך.</p>

        <div v-if="errorMsg" class="rpo-banner rpo-banner--error" role="alert">{{ errorMsg }}</div>

        <form @submit.prevent="submit" class="rpo-form">
          <label for="rpo-password" class="rpo-label">סיסמה חדשה</label>
          <input id="rpo-password" type="password" v-model="password" class="rpo-input" placeholder="לפחות 6 תווים" autocomplete="new-password" required />

          <label for="rpo-confirm" class="rpo-label">אימות סיסמה</label>
          <input id="rpo-confirm" type="password" v-model="confirm" class="rpo-input" placeholder="הזן/י שוב את הסיסמה" autocomplete="new-password" required />

          <button type="submit" class="rpo-submit" :disabled="isLoading">
            <span v-if="isLoading">שולח...</span>
            <span v-else>שמור סיסמה</span>
          </button>
        </form>
      </div>

      <div v-else class="rpo-success">
        <div class="rpo-success-icon">✓</div>
        <h2 class="rpo-title">הסיסמה עודכנה בהצלחה!</h2>
        <p class="rpo-sub">מועבר/ת לאתר...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPasswordOverlay',
  props: {
    token: { type: String, required: true },
  },
  data() {
    return { password: '', confirm: '', errorMsg: '', isLoading: false, done: false };
  },
  methods: {
    submit() {
      this.errorMsg = '';
      if (this.password.length < 6) { this.errorMsg = 'הסיסמה חייבת להכיל לפחות 6 תווים.'; return; }
      if (this.password !== this.confirm) { this.errorMsg = 'הסיסמאות אינן תואמות.'; return; }
      this.isLoading = true;
      this.api_call({
        url: 'password_reset_confirm',
        data: { token: this.token, new_password: this.password },
        onComplete: (res) => {
          this.isLoading = false;
          const payload = res && res.data && res.data.data;
          if (payload && payload.success) {
            if (payload.user_token) localStorage.setItem('user_token', payload.user_token);
            this.done = true;
            setTimeout(() => { this.$emit('close'); document.location = '/'; }, 2000);
          } else if (payload && payload.reason === 'invalid_token') {
            this.errorMsg = 'הקישור אינו תקין או שפג תוקפו. אנא בקש/י איפוס סיסמה מחדש.';
          } else {
            this.errorMsg = 'אירעה שגיאה. אנא נסה/י שוב.';
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.rpo-shell {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.8);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: var(--space-4);
}
.rpo-card {
  position: relative;
  width: 100%;
  max-width: 420px;
  background: var(--color-surface2, #1a1a1a);
  border: 1px solid var(--color-border, #2a2a2a);
  border-radius: var(--radius-lg, 16px);
  padding: 40px 32px;
  box-sizing: border-box;
}
.rpo-close {
  position: absolute;
  top: 16px;
  left: 16px;
  background: none;
  border: none;
  color: var(--color-textMuted, #888);
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  padding: 4px 8px;
  &:hover { color: #fff; }
}
.rpo-logo {
  font-size: 24px;
  font-weight: 800;
  color: var(--color-accent, #e11d2a);
  text-align: center;
  margin-bottom: 20px;
  letter-spacing: 2px;
}
.rpo-title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text, #fff);
  text-align: center;
}
.rpo-sub {
  margin: 0 0 24px;
  color: var(--color-textMuted, #888);
  font-size: 14px;
  text-align: center;
}
.rpo-banner {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 16px;
  &--error { background: rgba(224,65,65,0.12); border: 1px solid rgba(224,65,65,0.33); color: #fff; }
}
.rpo-form { display: grid; gap: 12px; }
.rpo-label { color: var(--color-textMuted, #888); font-size: 13px; font-weight: 600; display: block; margin-bottom: 4px; }
.rpo-input {
  width: 100%; height: 48px; padding: 0 14px;
  border-radius: 8px; border: 1px solid var(--color-borderHi, #333);
  background: var(--color-surface3, rgba(255,255,255,0.06));
  color: var(--color-text, #fff); font-size: 15px; box-sizing: border-box;
  &:focus { outline: none; border-color: var(--color-accent, #e11d2a); }
}
.rpo-submit {
  width: 100%; height: 48px;
  background: var(--color-accent, #e11d2a); color: #fff;
  border: none; border-radius: 8px; font-size: 15px; font-weight: 700;
  cursor: pointer; margin-top: 4px;
  &:hover:not(:disabled) { background: #c8111f; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
}
.rpo-success { text-align: center; padding: 16px 0; }
.rpo-success-icon {
  width: 56px; height: 56px; border-radius: 50%;
  background: rgba(90,200,90,0.15); border: 2px solid rgba(90,200,90,0.5);
  color: #6ecc6e; font-size: 24px;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 16px;
}
</style>
